import { gql } from '@apollo/client';

export const GET_WORKSPACE_FORM_SUBMISSIONS = gql`
  query GetUserWorkspaceFormSubmissions($input: WorkspaceFormSubmissionsInput!) {
    submissions: getWorkspaceSubmissions(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          updatedAt
          status
          createdAt
          statusDate
          status
          respondent {
            id
            lastName
            firstName
          }
          userRespondent {
            id
            lastName
            firstName
          }
          data {
            id
            answer
            question {
              id
              name
            }
          }
          # workspaceForm {
          #   id
          #   template {
          #     jsonData
          #   }
          # }
        }
      }
    }
  }
`;
